// Featured Collection Slider
var elements = document.querySelectorAll('.featured__collection-slider');

if(elements.length > 0){
  elements.forEach(function(elem) {
    var slideNum = Number(elem.querySelector('.swiper-wrapper').getAttribute('data-slide'));
    var slideSpace = 110;
  
    if(slideNum == 4){
      var slideSpace = 42;
    }
  
    if(elem.closest('.section__featured-collection')){
      var nextBtn = elem.closest('.section__featured-collection').querySelector('.swiper-button-next');
      var prevBtn = elem.closest('.section__featured-collection').querySelector('.swiper-button-prev');
    }
  
    if(elem.closest('.section__collection--list')){
      var nextBtn = elem.closest('.section__collection--list').querySelector('.swiper-button-next');
      var prevBtn = elem.closest('.section__collection--list').querySelector('.swiper-button-prev');
    }
    
    var elem = new Swiper(elem, {
      slidesPerView: 2,
      spaceBetween: 14,
      loop: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
        1281: {
          slidesPerView: slideNum,
          spaceBetween: slideSpace,
        },
      },
    });
  });
}

// Instagram Slider
var elem = document.querySelector('.instagram__list');

if (elem) {
  var flkty = new Flickity( elem, {
    imagesLoaded: true,
    contain: true,
    groupCells: true,
    initialIndex: 0,
    wrapAround: true,
    pageDots: false,
    cellAlign: "left"
  });
}

// Smooth scroll
document.addEventListener('DOMContentLoaded', function() {
  var forgotPassword = document.querySelector('.forgot__password');
  var loginPage = document.querySelector('.login__page');

  if (forgotPassword) {
    forgotPassword.addEventListener('click', function() {
      console.log('clicked');
      document.querySelector('.main__customer--col-login').classList.add('inactive');
      document.querySelector('.main__customer--col-login').classList.remove('active');
      document.querySelector('.main__customer--col-recover').classList.add('active');
      document.querySelector('.main__customer--col-recover').classList.remove('inactive');
    });    
  }

  if (loginPage) {
    loginPage.addEventListener('click', function() {
      document.querySelector('.main__customer--col-recover').classList.add('inactive');
      document.querySelector('.main__customer--col-recover').classList.remove('active');
      document.querySelector('.main__customer--col-login').classList.add('active');
      document.querySelector('.main__customer--col-login').classList.remove('inactive');
    });
  }
});

// Smooth scroll
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
  });
});

// Brands Slider
var elements = document.querySelectorAll('.brands__list--slider');
elements.forEach(function(elem) {
  new Flickity(elem, {
    imagesLoaded: true,
    contain: false,
    percentPosition: false,
    initialIndex: 0,
    wrapAround: true,
    pageDots: false,
    cellAlign: "left"
  });
});

// Image With Text Slider
var elements = document.querySelectorAll('.image__text--carousel');
elements.forEach(function(elem) {
    new Flickity(elem, {
    imagesLoaded: true,
    contain: false,
    percentPosition: false,
    initialIndex: 0,
    wrapAround: true,
    pageDots: false,
    cellAlign: "left",
    groupCells: true
  });
});

// Standard Text Slider
var elements = document.querySelectorAll('.standard__text--carousel');
elements.forEach(function(elem) {
    new Flickity(elem, {
    imagesLoaded: true,
    contain: false,
    percentPosition: false,
    initialIndex: 0,
    wrapAround: true,
    pageDots: false,
    adaptiveHeight: false,
    cellAlign: "left"
  });
});

// Header background change
var parent = document.querySelector('.header-wrapper');
var children = parent.querySelectorAll('.header__inline-menu .level__one-list');

parent.addEventListener('mouseover', function() {
  parent.classList.add('is-active');
});
parent.addEventListener('mouseout', function() {
  parent.classList.remove('is-active');
});

children.forEach(function(child) {
  child.addEventListener('mouseover', function() {
    parent.classList.add('is-active');
  });
  child.addEventListener('mouseout', function() {
    parent.classList.remove('is-active');
  });
});

var close_icon = document.querySelector('#menu-drawer drawer-close-button.header__icon');
var close_bg = document.querySelector('.header-wrapper');
close_icon.addEventListener("click", function() {
  close_bg.classList.remove('is-active');
});

// Filter accordion
document.addEventListener('DOMContentLoaded', function() {
  console.log('Dom loaded!!');
  const accordionItems = document.querySelectorAll('.custom__facets-item');

  accordionItems.forEach(item => {
    const title = item.querySelector('.custom__facets-header');
    const content = item.querySelector('.custom__facets-content');
    
    title.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      
      if (isOpen) {
        item.classList.remove('open');
      } else {
        item.classList.add('open');
      }
    });
  });

  
});

// Sorting
var selectButton = document.querySelector('.select-dropdown__button');
if (selectButton) {
  selectButton.addEventListener('click', function() {
    document.querySelector('.select-dropdown__list').classList.toggle('active');
    document.querySelector('.custom__sorting--arrow').classList.toggle('active');
  });
}

document.querySelectorAll('.select-dropdown__list-item').forEach(function(item) {
  item.addEventListener('click', function() {
    var itemValue = this.getAttribute('data-value');
    console.log(itemValue);
    document.querySelector('.select-dropdown__button span').textContent = this.textContent;
    document.querySelector('.select-dropdown__button').setAttribute('data-value', itemValue);
    document.querySelector('.select-dropdown__list').classList.toggle('active');
    document.querySelector('.custom__sorting--arrow').classList.toggle('active');
  });
});

/* add code in the below function which is to be executed After filter applied */
window.filterApplied = function(){
  document.querySelector(".select-dropdown__button span").innerHTML = document.querySelector("ul.select-dropdown__list input:checked").dataset.sort_value;
  document.querySelector('.select-dropdown__button').addEventListener('click', function() {
    document.querySelector('.select-dropdown__list').classList.toggle('active');
    document.querySelector('.custom__sorting--arrow').classList.toggle('active');
  });
}

document.addEventListener('click', function (event) {
  var target = event.target;
  if (target.classList.contains('order__btn')) {
    event.preventDefault();
    var orderNumber = target.getAttribute('data-order');
    document.querySelector('.tab-content.current').classList.add('hidden');
    document.querySelector('.customer__order--history .order__history--wrapper [data-order="' + orderNumber + '"]').classList.remove('hidden');
    document.querySelector('.customer__order--history .order__history--wrapper').classList.remove('hidden');
  }
  if (target.classList.contains('order__history--back')) {
    event.preventDefault();
    target.closest('.order__history--wrapper').classList.add('hidden');
    document.querySelector('.tab-content.current').classList.remove('hidden');
  }
});

function isDesktop() {
  return window.innerWidth > 768;
}

function Readmore() {
  var descriptions = document.querySelectorAll('.our__team--description');
  descriptions.forEach(function (description) {
    var paragraphs = description.querySelectorAll('p');
    var readMorediv = description.querySelector('.read-morediv');
    var readLessdiv = description.querySelector('.read-lessdiv');
    let ourTeamContent = description.closest(".our__team--content");
    let ourTeamImage = description.closest(".our__team--inner-wrap").querySelector('.our__team--image');
    let ourTeamContentHeight = ourTeamContent.offsetHeight;
    
    if (!readMorediv && !readLessdiv && paragraphs.length > 1) {
      readMorediv = document.createElement('div');
      readLessdiv = document.createElement('div');
      readMorediv.className = 'read-morediv';
      readLessdiv.className = 'read-lessdiv';

      var readMoreBtn = document.createElement('a');
      var readLessBtn = document.createElement('a');

      readMoreBtn.className = 'read-more-btn';
      readMoreBtn.textContent = 'Read More';
      readLessBtn.className = 'read-less-btn';
      readLessBtn.textContent = 'Read Less';

      readLessdiv.style.display = 'none';
      readMorediv.style.display = 'block';

      readMorediv.appendChild(readMoreBtn);
      readLessdiv.appendChild(readLessBtn);

      description.insertBefore(readMorediv, paragraphs[1]);
      description.appendChild(readLessdiv);

      for (var i = 1; i < paragraphs.length; i++) {
        paragraphs[i].style.display = 'none';
      }

      readMorediv.addEventListener('click', function () {
        for (var i = 1; i < paragraphs.length; i++) {
          paragraphs[i].style.display = 'block';
        }
        readMorediv.style.display = 'none';
        readLessdiv.style.display = 'block';
        this.closest('.swiper-slide').style.height = 'auto';
        this.closest('.swiper-wrapper').style.height = 'auto';
      });

      readLessdiv.addEventListener('click', function () {
        for (var i = 1; i < paragraphs.length; i++) {
          paragraphs[i].style.display = 'none';
        }
        readLessdiv.style.display = 'none';
        readMorediv.style.display = 'block';
        this.closest('.swiper-slide').style.height = 'auto';
        this.closest('.swiper-wrapper').style.height = 'auto';
      });
    } else if (isDesktop() && readMorediv && readLessdiv) {
      readMorediv.style.display = 'block';
      readLessdiv.style.display = 'none';
      for (var i = 1; i < paragraphs.length; i++) {
        paragraphs[i].style.display = 'none';
      }
    } else if (!isDesktop() && readMorediv && readLessdiv) {
      readMorediv.style.display = 'none';
      readLessdiv.style.display = 'none';
      for (var i = 1; i < paragraphs.length; i++) {
        paragraphs[i].style.display = 'block';
      }
    }else if (ourTeamImage.offsetHeight < ourTeamContent.offsetHeight && paragraphs.length > 0){
      readMorediv = document.createElement('div');
      readLessdiv = document.createElement('div');
      readMorediv.className = 'read-morediv';
      readLessdiv.className = 'read-lessdiv';

      var readMoreBtn = document.createElement('a');
      var readLessBtn = document.createElement('a');

      readMoreBtn.className = 'read-more-btn';
      readMoreBtn.textContent = 'Read More';
      readLessBtn.className = 'read-less-btn';
      readLessBtn.textContent = 'Read Less';

      readLessdiv.style.display = 'none';
      readMorediv.style.display = 'block';

      readMorediv.appendChild(readMoreBtn);
      readLessdiv.appendChild(readLessBtn);

      description.insertBefore(readMorediv, paragraphs[1]);
      description.appendChild(readLessdiv);

      let firstPTag = description.querySelector("p");
      let fixedContent = firstPTag.textContent;
      if (firstPTag) {
          let content = firstPTag.textContent.trim().split(' ');
          var truncatedContent = content.slice(0, 10).join(' ');
          firstPTag.textContent = truncatedContent;
      }

      for (var i = 1; i < paragraphs.length; i++) {
        paragraphs[i].style.display = 'none';
      }

      readMorediv.addEventListener('click', function () {
        for (var i = 1; i < paragraphs.length; i++) {
          paragraphs[i].style.display = 'block';
        }
        if (firstPTag) {
          firstPTag.textContent = fixedContent;
        }
        this.closest('.swiper-slide').style.height = Number(ourTeamContentHeight) + 50 + 'px';
        this.closest('.swiper-wrapper').style.height = 'auto';
        readMorediv.style.display = 'none';
        readLessdiv.style.display = 'block';
      });

      readLessdiv.addEventListener('click', function () {
        for (var i = 1; i < paragraphs.length; i++) {
          paragraphs[i].style.display = 'none';
        }
        if (firstPTag) {
          let content = firstPTag.textContent.trim().split(' ');;
          var truncatedContent = content.slice(0, 10).join(' ');
          firstPTag.textContent = truncatedContent;
        }
        this.closest('.swiper-slide').style.height = 'auto';
        this.closest('.swiper-wrapper').style.height = 'auto';
        readLessdiv.style.display = 'none';
        readMorediv.style.display = 'block';
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  if(isDesktop()){
    Readmore();
  }
});

window.addEventListener('resize', function () {
  Readmore();
});

function checkForDivElement() {
  if (document.querySelector('.swym-wishlist-detail-content')) {
    clearInterval(intervalId);
    console.log('At least one div element is present.');
    var vendorTitle = document.querySelectorAll('.swym-vendor-title');
    vendorTitle.forEach((element) => {
      var vendorText = element.innerText;
      var str = vendorText.split(":").pop();
      element.innerText = str;
    });
  } else {
    console.log('No div element found.');
  }
}

// Call the function every 1000 milliseconds (1 second)
var intervalId = setInterval(checkForDivElement, 1000);